import { Box } from "@mui/material";
import { ChokkankunIcon } from "components/icons/ChokkankunIcon";
import { useState, useEffect } from "react";

interface props {
  answer: string;
  word: string[];
  wordIndex: number;
  numOfCorrectAnswers: number;
  setNumOfCorrectAnswers: (numOfCorrectAnswers: number) => void;
  correctWords: string[];
  isCompleted: boolean;
}

const Answer: React.FC<props> = ({
  answer,
  word,
  wordIndex,
  correctWords,
  isCompleted,
}) => {
  const [answers, setAnswers] = useState<string[]>(word);
  const [correctAnswer] = useState(correctWords.map((word) => Array.from(word))[wordIndex]);
  const [iconHeight, setIconHeight] = useState<number>(0);

  const resizeIconHeight = () => {
    const height = window.innerWidth >= 900 ? window.innerWidth / 16 : 48;
    setIconHeight(height);
  };

  useEffect(() => {
    resizeIconHeight();
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      window.addEventListener("resize", resizeIconHeight);
      return () => window.removeEventListener("resize", resizeIconHeight);
    }
    return;
  }, [iconHeight]);

  useEffect(() => {
    if (correctAnswer.includes(answer)) {
      const correctCharIndices = correctAnswer.reduce(
        (arr: number[], correctChar, i) => ((
          correctChar === answer && arr.push(i), arr
        )),
        []
      );
      setAnswers((a) =>
        a.map((preAns, index) =>
          correctCharIndices.includes(index) ? answer : preAns
        )
      );
    }
  }, [answer, correctAnswer]);
  return (
    <Box width="33%" display="flex">
      {word.map((_char, index) => (
        <Box
          height={iconHeight}
          flexDirection={"row"}
          mx={1}
          position="relative"
          key={index}
          sx={{
            mb: { xs: "4px", md: 1 },
          }}
        >
          <ChokkankunIcon
            height={iconHeight}
            colorIndex={wordIndex}
            style={{
              animation: isCompleted ? `complete${index} 2s ease infinite` : "",
            }}
          />
          <Box
            style={{
              position: "absolute",
              transform: "translate(-50%, -50%)", //意味わかってない気がするので確認要
              // fontWeight: "bold",
              fontFamily: "yasashisa",
              animation: isCompleted ? `complete${index} 2s ease infinite` : "",
            }}
            sx={{
              top: isCompleted
                ? { xs: "16px", md: (35 * iconHeight) / 112 + "px" }
                : "50%",
              left: isCompleted
                ? { xs: "4px", md: (10.7695 * iconHeight) / 112 + "px" }
                : "52%",
              color: "black",
              fontSize: { xs: 18, md: (40 * iconHeight) / 112 },
            }}
          >
            {answers[index]}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default Answer;
